import { render } from "./SecurityPage.vue?vue&type=template&id=7a0a1db2"
import script from "./SecurityPage.vue?vue&type=script&lang=js"
export * from "./SecurityPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__